import React from 'react';
import { clsx } from 'clsx';
import { Loader2 } from 'lucide-react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  icon?: React.ReactNode;
}

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  icon,
  className,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 font-bold tracking-wider uppercase transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100';

  const variants = {
    primary: 'bg-foretell-accent hover:bg-foretell-accent-hover text-white shadow-[0_4px_30px_rgba(99,102,241,0.5)]',
    secondary: 'bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 text-white',
    ghost: 'hover:bg-white/5 text-slate-400 hover:text-white',
    danger: 'bg-rose-500/20 hover:bg-rose-500/30 border border-rose-500/30 text-rose-400',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-[10px] rounded-lg',
    md: 'px-4 py-2.5 text-xs rounded-xl',
    lg: 'px-6 py-3 text-sm rounded-2xl',
  };

  return (
    <button
      className={clsx(baseStyles, variants[variant], sizes[size], className)}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : icon ? (
        icon
      ) : null}
      {children}
    </button>
  );
}
